var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"c-alarm-extra-details-chip",style:(_vm.style)},_vm.$listeners),[_vm._t("default",function(){return [(_vm.icon)?_c('v-icon',{attrs:{"color":_vm.iconColor,"small":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }